<template>
  <div class="zon">
    <c-navbar v-if="isWebIM" title="售后详情"/>
    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
    <div v-if="!loading">
      <div class="new-div-by"></div>
      <ul class="div-by">
        <li class="li1">
          <van-row>
            <van-col span="4">
              <!-- <van-icon name="todo-list" size="50" :color="$theme.main_color_btn_bg" /> -->
              <img v-if="info.status == 'FINISH'" src="@/assets/image/detail_print@2x.png" alt="" class="img-icon">
              <img v-else-if="info.status == 'SALE_AFTER_REJECT' || info.status == 'ALREADY_CANCEL'" src="@/assets/image/detail_close@2x.png" alt="" class="img-icon">
              <img v-else-if="info.status == 'WAIT_CHECK'" src="@/assets/image/detail_wait-print@2x.png" alt="" class="img-icon">
              <img v-else src="@/assets/image/detail_wait-print@2x.png" alt="" class="img-icon">
            </van-col>
            <van-col span="10" class="f32"> {{
              info.showStatus || info.statusDisplayName
            }}</van-col>
            <van-col span="10" v-if="info.thirdAftersaleId !==null&&info.thirdAftersaleId && isCountdownShow && info.status== 'WAIT_CHECK'"> <span class="countText">倒计时: <span class="countTimer">{{countTimer}}</span></span> </van-col>
          </van-row>
          <van-row class="video_text" v-if="info.thirdAftersaleId !==null&&info.thirdAftersaleId && isCountdownShow && info.status== 'WAIT_CHECK' && info.userSendGoods">微信视频号售后单，商家超10天未处理，将自动审核通过；</van-row>
          <van-row class="video_text" v-if="info.thirdAftersaleId !==null&&info.thirdAftersaleId && isCountdownShow && info.status== 'WAIT_CHECK' && !info.userSendGoods">微信视频号售后单，商家超48小时未处理，将自动审核通过；</van-row>
        </li>
        <li>
          <!-- v-if="info.urgeOrder && info.urgeOrder.urgeId" --> 
          <abnormalItem type="after" :info="info" v-if="info.urgeOrder && info.urgeOrder.urgeId"/>
        </li>
        <li v-if="stepVisible">
          <!-- <DetailF2Comp :aftype="info.afterSaleType" :aftypeN="info.afterSaleTypeDisplayName" :afnode="info.afterFlowNode"></DetailF2Comp> -->
          <steps :currentVal="currentVal" :stepArray="stepArray"></steps>
        </li>
            <!-- <h3>订单轨迹</h3> -->
        <!-- <li class="li2" v-show="info.afterSaleType != 'CHANGE_PRODUCT'">
          <div class="div">
            <FollowComp ref="FollowComp" :subid="info.subOrderId"></FollowComp>
          </div>
        </li> -->
        <li>
          <DetailFComp :steps="info.checkFlowList" :stepsRow="info"></DetailFComp>
        </li>
        <li v-if="info.expressCompany && info.expressNo">
          <div class="div-mia">
            <h5 class="cor33">商品寄回物流单号</h5>
            <ul>
              <li>
                <van-row type="flex" justify="end" align="center">
                  <van-col span="8">{{ info.expressCompany }}</van-col>
                  <van-col span="13" class="cor99 rig">{{
                    info.expressNo
                  }}</van-col>
                  <van-col
                    span="3"
                    class="rig"
                    @click="copyFun(info.expressNo)"
                  >
                    <van-tag plain type="warning">复制</van-tag>
                  </van-col>
                </van-row>
              </li>
            </ul>
          </div>
        </li>
        <!-- <li>
          <div class="div-mia">
            <ul>
              <li style="margin-bottom: 0">
                <van-row>
                  <van-col span="8" class="w1">{{
                    radio3Boolean[info.afterSaleType] || "退款总金额"
                  }}</van-col>
                  <van-col span="16" class="rig w2"
                    >￥{{
                      info.actualRefundPrice
                        ? info.actualRefundPrice
                        : info.checkPrice
                        ? info.checkPrice
                        : info.lastRefundPrice
                    }}</van-col
                  >
                </van-row>
              </li>
            </ul>
          </div>
        </li> -->
        <li>
          <DetailGComp
            :imgs="info.itemVO"
            role="bee"
            :orderDetails="info"
          ></DetailGComp>
        </li>
        <li>
          <div class="div-mia">
            <ul>
              <li v-if="info.keChuanInfoVO">
                <van-row type="flex" justify="end" align="center">
                  <van-col span="8">同步科传信息</van-col>
                  <van-col span="16" class="rig" @click="showDetail()">
                    <van-tag plain type="warning" color="#999" class="look-tag"
                      >查看详情</van-tag
                    >
                  </van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" align="center">
                  <van-col span="5">售后单号</van-col>
                  <van-col span="16" class="rig">{{ info.returnCode }}</van-col>
                  <van-col
                    span="3"
                    class="rig"
                    @click="copyFun(info.returnCode + '')"
                  >
                    <van-tag plain type="warning" class="fz">复制</van-tag>
                  </van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" align="center">
                  <van-col span="5">订单号</van-col>
                  <van-col span="16" class="rig">{{ info.subOrderCode }}</van-col>
                  <van-col
                    span="3"
                    class="rig"
                    @click="copyFun(info.subOrderCode + '')"
                  >
                    <van-tag plain type="warning" class="fz">复制</van-tag>
                  </van-col>
                </van-row>
              </li>

              <li v-if="info.outOrderCode">
                <van-row type="flex" align="center">
                  <van-col span="5">品牌订单编号</van-col>
                  <van-col span="16" class="rig">{{ info.outOrderCode }}</van-col>
                  <van-col
                    span="3"
                    class="rig"
                    @click="copyFun(info.outOrderCode + '')"
                  >
                    <van-tag plain type="warning" class="fz">复制</van-tag>
                  </van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" justify="start" align="center">
                  <van-col >申请时间</van-col>
                  <van-col  class="rig">{{ info.applyTime }}</van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" justify="start" align="center">
                  <van-col >售后类型</van-col>
                  <van-col  class="rig">{{
                    info.afterSaleTypeDisplayName
                  }}</van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" justify="start" align="center">
                  <van-col >订单状态</van-col>
                  <van-col  class="rig">{{
                    info.statusDisplayName
                  }}</van-col>
                </van-row>
              </li>
              <li>
                <van-row type="flex" justify="start" align="center">
                  <van-col >{{ info.afterSaleTypeDisplayName}}原因</van-col>
                  <van-col  class="rig">{{ info.reasonDetailDesc || info.reason }}</van-col>
                </van-row>
              </li>

              <li v-if="info.afterSaleType != 'CHANGE_PRODUCT'">
                <van-row type="flex" justify="start" align="center">
                  <van-col >{{info.afterSaleTypeDisplayName + '总额'}} </van-col>
                  <van-col  class="rig"> 
                    <span class="money" v-price="info.actualRefundPrice
                        ? info.actualRefundPrice
                        : info.checkPrice
                        ? info.checkPrice
                        : info.lastRefundPrice"></span>

                    <div v-if="info.giftCardActualRefundPrice" class="refund-gift-card">
                      <span v-if="info.cashActualRefundPrice">
                        (现金退回￥{{info.cashActualRefundPrice}}，礼品卡退回￥{{info.giftCardActualRefundPrice}})
                      </span>
                      <span v-else>(礼品卡退回￥{{info.giftCardActualRefundPrice}})</span>
                    </div>
                  </van-col>
                </van-row>
              </li>
              <li v-else>
                <van-row type="flex" justify="start" align="center">
                  <van-col >{{info.afterSaleTypeDisplayName + '总数'}} </van-col>
                  <van-col  class="rig money">X{{info.count}}</van-col>
                </van-row>
              </li>

              <li v-if="'2,3'.includes(info.buyType)">
                <van-row type="flex" justify="start" align="center">
                  <van-col >退积分： </van-col>
                  <van-col  class="rig money" style="font-family: 'number-bold';font-size:14px">{{info.refundPointNum}} 积分</van-col>
                </van-row>
              </li>

              <li>
                <van-row type="flex" justify="start" align="center">
                  <van-col >{{info.afterSaleTypeDisplayName}}描述</van-col>
                  <van-col  class="rig llt">{{ info.remark }}</van-col>
                </van-row>
              </li>
            </ul>
            <van-row
              v-if="info.imageInfoListUser && info.imageInfoListUser.length > 0"
            >
              <van-col span="5" style="color:#808080">图片凭证</van-col>
              <van-col span="20">
                <van-grid :border="false" :column-num="3">
                  <van-grid-item
                    v-for="(item, index) in info.imageInfoListUser"
                    :key="index"
                  >
                    <van-image
                      height="70"
                      width="70"
                      :src="item.imageUrl"
                      @click="showMaxImgFun([item.imageUrl])"
                    />
                  </van-grid-item>
                </van-grid>
              </van-col>
            </van-row>
          </div>
        </li>
        <li v-if="info.itemVO.length > 0 && info.afterSaleType != 'JUST_FREIGHT' ">
          <div class="div-mia">
            <div class="after_titlc">售后商品</div>
            <div class="after_goods_list" v-for="(item,index) in info.itemVO" :key="index">
              <div class="after_good">
                  <div class="img">
                    <img :src="item.skuImageKey">
                    <div
                      v-if="item.groupPeopleNum"
                      class="group-buying-people-label"
                      :style="{backgroundColor: item.groupBgColor, color: item.groupTextColor}"
                    >{{item.groupPeopleNum}}人团</div>
                  </div>
                  <div class="info">
                    <div class="info_good">
                      <span>{{item.goodsName}}</span>
                      <span v-if="!'2,3'.includes(info.buyType)" class="" v-price="item.goodsPrice"></span>
                    </div>
                    <div class="info_sku">
                      <span style="flex:1">{{item.beeAttributeValues}}</span>
                      <span>X {{item.goodsCount}}</span>
                    </div>
                    <div class="info_sku" style="font-weight:bold;color:#333333;display: inline-block;font-family: DINAlternate-Bold, DINAlternate;" v-if="'2,3'.includes(info.buyType)">
                      <div v-if="info.pointBuyType == 2">
                        {{item.goodsPrice}} 元
                      </div>
                      <div v-else>
                        <span>{{item.exchangePoint}} 积分</span><span v-if="info.buyType == 3">+{{item.goodsPrice}} 元</span>
                      </div> 

                    
                    </div>

                  </div>
              </div>
              <div class="price-point">
                <div v-if="'2,3'.includes(info.buyType)">
                  <div class="sales">退积分：<span class="money" style="font-family: DINAlternate-Bold, DINAlternate;">{{item.saleAfterPoint}} <span style="font-size:12px">积分</span></span></div>
                </div>
                <div v-if="info.buyType != 2" class="sales" style="flex: 1;">售后金额：<span class="money" v-price="item.saleAfterPrice"></span> </div>
              </div>

            </div>
           
          </div>
        </li>
      </ul>
      <div class="div-dib navbar-fixed" v-if="!isWebIM && info.shadowBranchIf != 1">
        <div class="auit-info" v-if="!info.mallCanAudit">
          本订单由品牌系统处理售后
        </div>
        <div class="print_btn" @click.stop="print_ticket($event)" :class="{'disabled':printType==3||info.ticketId}" v-if="info.status=='FINISH'&& isEnableTicket == '启用'">
            <span v-if="printType==1&&!info.ticketId">
              打印小票
            </span>
            <span v-else-if="printType==2">
              打印中
            </span>
            <span v-else :printType="3">
              已打印小票
            </span>
            
             <img v-if="printType==2" src="https://img.chinabeego.com/uploadfile/2023/5/17/16843249059692059381552461341.png" alt="" srcset="" class="hold_on">
        </div>
        <span v-if="info.afterSaleType!= 'MERGE_ITEM_CUSTOM_COMPLAIN_REFUND'">
          <ContactComp :contactId="info.userId" role="bees">联系客户</ContactComp>
        </span>
        <!-- pointBranchBee 积分店铺蜜蜂帐号 -->
        <div v-if="info.mallCanAudit && info.isBranchCheck == 'y' && info.afterSaleType!= 'MERGE_ITEM_BEES_REFUND' && (!info.pointBranchBee || (info.pointBranchBee &&  info.pointRelatedBranchId == undefined ))">
          <van-button
            @click="goRejectFun"
            class="div-btn-a"
            round
            plain
            normal
            hairline
            size="small">
            拒绝
          </van-button>
          <van-button
            @click="goAgreeFun"
            :style="{'border-color': $theme.main_color_btn_bg, 'color': $theme.u_main_color_btn_title}"
            class="div-btn-a mal-10"
            plain
            round
            size="small">
            同意
          </van-button>
        </div>
        <div
          v-if="
            info.isBranchCheckSecnnd == 'y' && info.mallCanAudit &&
            info.afterSaleType != 'CHANGE_PRODUCT' && !info.pointBranchBee
          "
        >
          <van-button
            @click="rejectVisibleSecond = true"
            class="div-btn-a"
            plain
            round
            size="small"
            >拒绝退款</van-button
          >
          <van-button
            @click="yesVisibleFun('second')"
            class="div-btn-a mal-10"
            plain
            round
            size="small"
            >同意退款</van-button
          >
        </div>
        <!-- 客户申请换货已经寄回货物,待卖家再次寄出货物 -->
        <span
          v-if="
            info.afterSaleType == 'CHANGE_PRODUCT' &&
            info.branchExpressEnable == 'y' &&
            info.expressCompany &&
            info.expressNo && !info.pointBranchBee
          "
        >
          <van-button
            v-if="info.branchSendExpresscompany && info.branchSendExpressno"
            @click="goPageExpress('editor')"
            class="div-btn-a"
            plain
            round
            size="small"
            >修改换货信息</van-button
          >
          <van-button
            v-else
            @click="goPageExpress('add')"
            class="div-btn-a"
            plain
            round
            size="small"
            >寄货</van-button
          >
        </span>
        <!-- 拒绝换货可查看拒绝原因 -->
        <span
          v-if="
            info.afterSaleType == 'CHANGE_PRODUCT' &&
            info.status == 'SALE_AFTER_REJECT' && !info.pointBranchBee
          "
        >
          <van-button
            v-if="info.branchRejectReason"
            @click="rejectInfoVisible = true"
            class="div-btn-a"
            plain
            round
            size="small"
            >拒绝原因</van-button
          >
        </span>
        <span v-if="info.stopSaleAfter == 'y' && !info.pointBranchBee">
          <van-button
            @click="salesAfterShow=true"
            class="div-btn-a aaa"
            plain
            round
            size="small"
          >终止售后</van-button>
        </span>
      </div>
      <van-dialog
        v-model="rejectVisible"
        show-cancel-button
        @confirm="doSumit('n')"
        confirm-button-color="#f8a651"
      >
        <div class="modal_border">
          <van-field
            v-model="remark"
            rows="3"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入不通过原因"
          />
        </div>
      </van-dialog>
      <van-overlay z-index="100" :show="yesVisible" @click="yesVisible = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="block-div">
              <div class="block-div-sales">{{info.afterSaleTypeDisplayName}} <span class="status">{{info.orderStatusDisplayName}}</span></div>
              <h5 class="text">
                退款金额
                <span>
                  {{
                  info.afterSaleType == "WAIT_RECEIVE_JUST_MONEY"
                    ? "注意：您的店铺商品已发货"
                    : ""
                }}
                </span>
                
              </h5>
              <div class="content">
                <!--  :disabled="
                    !info.afterSaleType == 'JUST_MONEY' &&
                    !info.afterSaleType == 'JUST_FREIGHT'
                  " -->
                <van-field
                  class="bor"
                 disabled
                  type="number"
                  v-model="checkPrice"
                  :placeholder="`退款金额,最大可退(${info.lastRefundPrice})`"
                />

                <h5 class="text">
                  退积分
                </h5>
                <van-field
                  class="bor"
                  disabled
                  type="number"
                  v-model="refundPointNum"
                  :placeholder="`退积分,最大可退(${info.refundPointNum})`"
                />

                <!-- <div v-if="info.adjustRefundSumPrice" class="btext">
                  已减去 {{ info.adjustRefundSumPrice }} 多退调账金额
                </div> -->
                <h5 class="text mat-10">
                  上传凭证
                  <span>
                    {{
                    info.afterSaleType == "WAIT_RECEIVE_JUST_MONEY"
                      ? "请上传已退款的商品图"
                      : ""
                  }}
                  </span>
                  
                </h5>
                <div class="img_up">
                  <div class="voucherImgKeys" v-if="voucherImgUrls.length > 0">
                    <div
                      v-for="(item, idx) in voucherImgUrls"
                      :key="idx"
                      class="img_up_div"
                    >
                      <van-image
                        class="img-up"
                        width="90"
                        height="90"
                        :src="item.url"
                      />
                      <van-icon
                        name="cross"
                        @click="close(idx)"
                        class="close"
                      />
                    </div>
                  </div>
                  <div
                    v-if="voucherImgUrls.length <= 3"
                    @click="voucherImgKeysFun"
                    class="div-up"
                  >
                    <van-icon class="div-up-1" name="plus" size="30" />
                  </div>
                </div>
                <div class="bu_hr" v-if="info.adjustPaymentSumPrice"></div>
                <!-- <div class="bu_div" v-if="info.adjustPaymentSumPrice">
                  <p class="p1">调账补款金额</p>
                  <p class="p2">{{ info.adjustPaymentSumPrice }}</p>
                </div> -->
                <p class="tips">
                  温馨提示
                  <br/>
                  {{
                    info.afterSaleType == "WAIT_RECEIVE_JUST_MONEY" || info.afterSaleType == "JUST_MONEY"
                      ? "请确认商品是否已发货，未发货才能退款哦！"
                      : info.afterSaleType == "CHANGE_PRODUCT"
                      ? '请确认收到商品是否完好，才能换货哦！'
                      : info.afterSaleType == "JUST_PRODUCT"
                      ? '请确认收到商品并检查退回商品是否完好，才可退款哦！'
                      : '请认真核对订单以及物流发货情况，已真实发货，又同意退款，将造成货钱两空的损失'
                  }}
                  <br/>
                  <!--判断 退款后是否还符合送赠品门槛 -->
                  <span class="tips">{{info.isSendBockGift == 1?'请注意：用户订单包含赠品，用户选择寄回赠品，请在收货时确认赠品是否退回。': info.isSendBockGift == 2 ? '请注意：用户订单包含赠品，用户未选择寄回赠品，请在收货时确认赠品是否退回。':''}}</span> <br/>
                  <span class="tips" v-if="info.giftFlag == 1">请注意：本订单是赠品订单，请先核实情况再处理售后。</span><br/>
                  <span class="tips" v-if="isGiftAfter">此商品订单退款后，将不再符合满赠活动赠送门槛，若不再赠送赠品，请及时关闭赠品订单。</span>
                </p>
                <van-checkbox
                  v-model="checked"
                  :checked-color="$theme.main_color_btn_bg"
                  icon-size="16"
                >
                  情况已核实，确认无误
                </van-checkbox>
              </div>
            </div>
            <van-button class="btn btnlfte" type="default" @click="yesVisible = false"
              >取消</van-button
            >
            <van-button
              :loading="doSumitLoading"
              class="btn yel-b btnright"
              type="default"
              @click="doSumit('y')"
              >确认</van-button
            >
          </div>
        </div>
      </van-overlay>

      <van-action-sheet v-model="backAddressVisible" :closeable="false">
        <div class="shet">
          <div class="lef">选择客户寄回收货地址</div>
          <div class="rig" @click="addAdressVisebelOpenFun">添加</div>
        </div>
        <div class="div-content">
          <div class="d-r">
            <van-field name="radio">
              <template #input>
                <van-radio-group v-model="radio">

                  <van-radio
                    v-for="(item, idx) in resonList"
                    :key="idx"
                    :name="item.id"
                    :checked-color="$theme.main_color_btn_bg"
                  >
                    <slot>
                      <div>
                        <span class="mr-10">{{ item.userName }}</span>
                        <span>{{ item.userMobile }}</span>
                      </div>
                      <p class="cor99">
                        {{ item.provinceName }}{{ item.cityName
                        }}{{ item.areaName }}{{ item.address }}
                      </p>
                    </slot>
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="d-que">
            <van-row>
              <van-col span="12" class="d-que-l">
                <van-button
                  class="div-btn mrg wt tt"
                  size="mini"
                  @click="backAddressVisible = false"
                  >取消</van-button
                >
              </van-col>
              <van-col span="12">
                <van-button
                  class="div-btn tt yel"
                  size="mini"
                  @click="checkAddresListFun"
                  >确认</van-button
                >
              </van-col>
            </van-row>
          </div>
        </div>
      </van-action-sheet>

      <van-overlay
        :show="addAddressVisible"
        z-index="100"
        @click="addAddressVisible = false"
      >
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="block-div">
              <van-field
                readonly
                clickable
                :value="shiqu"
                label="省市区"
                placeholder="请选择省市区"
                @click="showArea = true"
              />
              <van-field
                v-model="addAdressForm.address"
                label="详细地址"
                placeholder="请输入详细地址"
              />
              <van-field
                v-model="addAdressForm.userName"
                label="收货人姓名"
                placeholder="请输入收货人姓名"
              />
              <van-field
                v-model="addAdressForm.userMobile"
                label="收货人手机"
                placeholder="请输入收货人手机"
              />
            </div>
            <van-button
              class="btn"
              type="default"
              @click="addAdressVisebelOpenFun"
              >取消</van-button
            >
            <van-button
              :loading="addAdressFormLoading"
              class="btn yel-b"
              type="default"
              @click="checkAdFun"
              >确认</van-button
            >
          </div>
        </div>
      </van-overlay>
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-overlay
        z-index="100"
        :show="rejectVisibleSecond"
        @click="rejectVisibleSecond = false"
      >
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="block-div">
              <h5 class="text">拒绝原因</h5>
              <div class="content">
                <van-field
                  style="border: 0.5px solid #cccccc"
                  v-model="remark"
                  rows="2"
                  autosize
                  type="textarea"
                  maxlength="50"
                  placeholder="请输入拒绝原因"
                  show-word-limit
                />
                <h5 class="text mat-10">上传凭证</h5>
                <div class="img_up">
                  <div class="voucherImgKeys" v-if="voucherImgUrls.length > 0">
                    <div
                      v-for="(item, idx) in voucherImgUrls"
                      :key="idx"
                      class="img_up_div"
                    >
                      <van-image
                        class="img-up"
                        width="90"
                        height="90"
                        :src="item.url"
                      />
                      <van-icon
                        name="cross"
                        @click="close(idx)"
                        class="close"
                      />
                    </div>
                  </div>
                  <div
                    v-if="voucherImgUrls.length <= 3"
                    @click="voucherImgKeysFun"
                    class="div-up"
                  >
                    <van-icon class="div-up-1" name="plus" size="30" />
                  </div>
                </div>
                <p class="tex-p">
                  提交平台审核，平台将会与快递、客户、店铺核实原因后，客观做出处理，是否与客户退款，如是商家问题，则有店铺承担退款
                </p>
              </div>
            </div>
            <van-button
              class="btn"
              type="default"
              @click="rejectVisibleSecond = false"
              >取消</van-button
            >
            <van-button
              :loading="doSureSecondLoading"
              class="btn yel-b"
              type="default"
              @click="doSureSecondFun('n')"
              >确认</van-button
            >
          </div>
        </div>
      </van-overlay>

      <van-popup
        round
        v-model="rejectInfoVisible"
        closeable
        position="bottom"
        @close="rejectInfoVisible = false"
      >
        <!-- <RejectInfo
          @closeModal="rejectInfoVisible = false"
          @callbackShowMaxImgFun="showMaxImgFun"
          :rejectInfo="info"
        /> -->
      </van-popup>
    </div>
    <!-- 科传详情弹窗 -->
    <van-action-sheet v-model="show" title="">
      <ul class="content_ul">
        <li>
          <span>科传销售单号</span>
          <span>{{
            this.info.keChuanInfoVO && this.info.keChuanInfoVO.orderNo
          }}</span>
        </li>
        <li>
          <span>同步金额</span>
          <span
            >￥{{
              this.info.keChuanInfoVO && this.info.keChuanInfoVO.price
            }}</span
          >
        </li>
        <!-- <li v-if="this.info.keChuanInfoVO && this.info.keChuanInfoVO.operationName">
          <span>操作蜜蜂</span>
          <span>{{
            this.info.keChuanInfoVO && this.info.keChuanInfoVO.operationName
          }}</span>
        </li> -->
      </ul>
      <van-button class="back_btn" @click="show = !show">返回</van-button>
    </van-action-sheet>

    <!-- 终止售后 -->
    <van-dialog v-model="salesAfterShow"  :before-close="onBeforeClose"   title="终止售后" confirm-button-text="确认终止" confirm-button-color="#007AFF" show-cancel-button>
      <div class="saleView">
        <div class="text">终止原因：</div>
        <van-field
          v-model="salesAfterMessage"
          rows="3"
          autosize
          type="textarea"
          placeholder="请输入留言"
        />
      </div>
    </van-dialog>

    <van-dialog v-model="externalCouponConfirm.show"  title="提示" show-cancel-button @confirm="onExternalCouponConfirm">
      <div class="dialog1">
        <template v-if="externalCouponConfirm.status === 'USABLE'">
          <van-checkbox v-model="externalCouponConfirm.checked" shape="square">虚拟商品对应的外部优惠券未使用，是否将券作废？</van-checkbox>
          <div class="warning1">注意：若需作废，请勾选后再点击确认。</div>
        </template>
        <template v-else>虚拟商品对应的外部优惠券已使用/无效/过期，请确认是否退款？</template>
      </div>
    </van-dialog>

  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
import toolsSteps from "@/utils/steps";
import DetailAComp from "@/views/me/components/detailA";
import DetailFComp from "@/views/me/components/detailF";
import DetailF2Comp from "@/views/me/components/detailF2";
import DetailGComp from "@/views/me/components/detailG";
import ContactComp from "@/views/me/components/contactComp";
import FollowComp from "@/views/beeorder/components/followSubOrder";
import AreaList from "@/utils/area.js";
import { Toast, Dialog } from "vant";
import RejectInfo from "@/views/beeorder/components/rejectInfo";
import abnormalItem from "./components/abnormalItem";
import steps from "@/views/me/components/steps";
import { get } from "https";


export default {
  data() {
    var isEnableTicket = localStorage.getItem('isEnableTicket') || '禁用'
    return {
      isWebIM: window.isWebIM,
      isEnableTicket:isEnableTicket,
      printType:1,
      timer:'',
      isCountdownShow:false,
      countTimer:'',
      show: false,
      afterId: this.$route.query.afterId || "",
      loading: false,
      info: {
        mainOrderLabel: "售后处理中",
        lastRefundPrice: "",
        frightPrice: "",
        goodPrice: "",
        checkFlowList: [],
        itemVO: [],
        voucherImgKeys: "",
        imageInfoList: [],
      },
      remark: "",
      checkPrice: "",
      refundPointNum:"",
      rejectVisible: false,
      yesVisible: false,
      backAddressVisible: false,
      voucherImgUrls: [],
      voucherImgKeys: [],
      radio: "",
      resonList: [],
      addAddressVisible: false,
      showArea: false,
      shiqu: "",
      areaList: AreaList,
      addAdressFormLoading: false,
      addAdressForm: {
        address: "",
        areaId: 0,
        areaName: "",
        branchId: "",
        cityId: 0,
        cityName: "",
        provinceId: 0,
        provinceName: "",
        userMobile: "",
        userName: "",
      },
      rejectVisibleSecond: false,
      doSureSecondLoading: false,
      doSumitLoading: false,
      checked: false,
      radioFormat: {
        JUST_PRODUCT: "退款原因",
        JUST_MONEY: "仅退款原因",
        CHANGE_PRODUCT: "换货原因",
        MERGE_ITEM_CUSTOM_COMPLAIN_REFUND: "申请原因",
      },
      radio3Boolean: {
        JUST_PRODUCT: "退款总金额",
        JUST_MONEY: "退款总金额",
        CHANGE_PRODUCT: "换货总金额",
      },
      radio4Boolean: {
        JUST_PRODUCT: "问题描述",
        JUST_MONEY: "问题描述",
        CHANGE_PRODUCT: "换货说明",
      },
      rejectInfoVisible: false,
      rejectInfo: {},
      saleAfterType:{
        SUB_REFYBD_JUST_MONEY: '子订单（仅退款），待发货子订单全退',
        JUST_FREIGHT: '退运费，子订单退运费',
        JUST_MONEY: "仅退款，商品项仅退款（单个）",
        JUST_PRODUCT: "退货退款，商品项退货退款（单个）",
        CHANGE_PRODUCT: "换货，商品项换货（单个），目前不涉及退钱", 
        PLATFORM_REFUND:'平台退款，客诉退款',
        WAIT_RECEIVE_JUST_MONEY:'仅退款，待售后商品项退款（单个）',
        MERGE_ITEM_BEES_REFUND:'仅退款，待发货蜜蜂或店铺发起的商品项退款（多个）',
        MERGE_ITEM_CUSTOM_COMPLAIN_REFUND: "客诉退款，客诉后台发起商品项退款（多个）",
      },
      salesAfterShow:false,
      salesAfterMessage:'',
      stepArray :[],
      currentVal:'',

      isGiftAfter:false,
      externalCouponConfirm: {
        checked: false,
        show: false,
        status: '',
      }
    };
  },
  beforeDestroy(){
    this.clearTimer();
  },
  methods: {
    print_ticket($event){ // 打印小票
      console.log($event);
      if (this.printType == 3||this.printType==2 || this.info.ticketId) { 
        return
      }
      this.printType = 2;
      http({
        url: "order/app/newafter/bee/printAfterTicket/"+this.info.id,
        method: "post"
      }).then(res => {
        if (res.code==200) {
          Toast(res.message);
          this.printType = 3
        }else {
          this.printType = 1
          Toast(res.message);

        }
        
      }).catch(err => {
        this.printType = 1
      })
    },
    onBeforeClose(action, done){
      if(action =='confirm'){
        if(!this.salesAfterMessage){
          Toast("请填写终止售后原因!");
          return done(false);
        }else{
          this.getCancelAfterShow();
          done()
        }
      }else{
        return done();
      }
    },
    getCancelAfterShow(){
      let param ={
        afterId:this.afterId,
        remark:this.salesAfterMessage
      }
      http({
        url: "order/admin/afternew/order/admin/cancelAfter",
        method: "post",
        parmes: param,
      }).then((rps) => {
        this.loading = false;
        if(rps.code == 200 && rps.data){
          this.salesAfterShow = false;
          this.init()
        }
      });
    },
    countDown() {
       this.timer = setInterval(()=>{
        let  userSendGoods =this.info.userSendGoods;
        let _time =  userSendGoods ? this.info.userSendGoodsTime.replace(/-/g, '/') : this.info.applyTime.replace(/-/g, '/')
        let endDate = new Date(_time);
        if(userSendGoods){
          endDate.setDate(endDate.getDate() + 10); // 加两天
        }else{
          endDate.setDate(endDate.getDate() + 2); // 加两天
        }
        _time = endDate.getTime();  // 结束时间
        let newTime = new Date().getTime()  // 当前时间
        if(_time > newTime ){
          let time = (_time - newTime) / 1000
          if(userSendGoods){
            let d = this.timeFormat(parseInt(time/60/60/24));
            let hou = this.timeFormat(parseInt(time /60 / 60 %24))
            let min = this.timeFormat(parseInt(time /60 % 60 ))
            let sec = this.timeFormat(parseInt(time % 60))
            var countTimer =d +"天"+ hou + ':' + min + ':' + sec

          }else{
            let hou = this.timeFormat(parseInt(time /60 / 60 ))
            let min = this.timeFormat(parseInt(time /60 % 60 ))
            let sec = this.timeFormat(parseInt(time % 60))
            var countTimer = hou + ':' + min + ':' + sec
          }
       
          this.countTimer = countTimer
          this.isCountdownShow = true
        }else{
            this.isCountdownShow = false
        }

       },1000)
       
    },
    clearTimer(){
        clearInterval(this.timer)
    },
        /**
     * 小于10的格式化函数
     */
    timeFormat(param) {
      return param < 10 ? '0' + param : param;
    },
    showDetail() {
      if (this.info.keChuanInfoVO) {
        this.show = !this.show;
      }
    },
    init() {
      this.loading = true;
      let param = {
        appType: "",
        id: this.afterId,
        // id:24265,
        pageNum: 0,
        pageSize: 0,
      };

      http({
        url: "order/app/newafter/bees/detail",
        method: "post",
        parmes: param,
      }).then((rps) => {
        this.loading = false;
        this.info = rps.data;
        if(this.info.thirdAftersaleId !==null&&this.info.thirdAftersaleId){
           this.countDown()
        }
        this.stepArray =  rps.data.afterAuditFlow;
        this.currentVal =  rps.data.afterFlowNode;

      });
    },
    copyFun(code) {
      Util.copyText(code);
    },
    yesVisibleFun() {
      this.$dialog.confirm({
        message: this.info.afterSaleType == 'JUST_PRODUCT' && this.info.afterFlowNode == 'BRANCH_FIRST_AUDIT' ?'确定同意退货退款？':'确定同意退款？',
        cancelButtonColor:'#666666',
        confirmButtonColor:'#007AFF'
      })
        .then(() => {
          this.checkPrice = this.info.lastRefundPrice;
          this.refundPointNum = this.info.refundPointNum;
          
          // 第一次
          if(this.info.afterSaleType == 'JUST_PRODUCT' && this.info.afterFlowNode == 'BRANCH_FIRST_AUDIT'){
            this.resonList.length == 0 && this.getAddresListFun();
            this.backAddressVisible = true
          }else{
            this.yesVisible = true;
            if(this.info.orderStatus == 'WAIT_SEND' &&  this.info.giveGift){
              this.getIsNeedGiftAfter();
            }
          }
        })
        .catch(() => {
          // on cancel
        });
    },

    // 增加文案接口的判断
    getIsNeedGiftAfter(){
      let itemApplyList = this.info.itemVO.map(_item=>{
        // return _item.id
        return{
          orderItemId:_item.id,
          applyDecimal:_item.saleAfterPrice
        }
      })
      let param ={
        subOrderId:this.info.subOrderId,
        itemApplyList,
        // applyDecimal:this.checkPrice,
        afterId:this.info.id
      }
      http({
        url: "order/app/newafter/getIsNeedGiftAfter",
        method: "post",
        parmes: param
      }).then(rps => {
        this.isGiftAfter = rps.data
      })
    },
    doSumit(isPass, status) {
      if (isPass == "y") {
        if (!this.checked) {
          Toast("请勾选核实情况后再确认提交");
          return;
        }
        if (!this.checkPrice) {
          Toast("退款金额不能为空");
          return;
        } else {
          if (Number(this.checkPrice) < 0) {
            Toast("必须大于0");
            return;
          }
          if (Number(this.checkPrice) > this.info.lastRefundPrice) {
            Toast("必须小于可退款数");
            return;
          }
        }
        if (
          this.info.afterSaleType == "JUST_PRODUCT" &&
          this.info.isBranchCheck == "y"
        ) {
          //同意用户已经收货订单完成后商品项的退货退款
          this.yesVisible = false;
          this.resonList.length == 0 && this.getAddresListFun();
          this.backAddressVisible = true;
        } else {
          if (this.externalCouponConfirm.checked) {
            this.abolishExternalCoupon();
          }
          this.info.isBranchCheckSecnnd == "y"
            ? this.doSureSecondFun("y")
            : this.doSureFun(isPass);  
        }
      } else {
        this.doSureFun(isPass);
      }
    },
    doSureFun(isPass) {
      let param = {
        checkPrice: this.checkPrice,
        refundPointNum: this.refundPointNum,
        id: this.info.id,
        isPass: isPass,
        reason: "",
        remark: this.remark,
        voucherImgKeys: this.voucherImgKeys.join(",") || "",
        branchAddressId: this.radio || "",
      };
      this.doSumitLoading = true;
      http({
        url: "order/admin/afternew/order/check",
        method: "post",
        parmes: param,
      }).then((rps) => {
        this.loading = false;
        this.yesVisible = false;
        this.backAddressVisible = false;
        this.rejectVisible = false;
        this.doSumitLoading = true;
        this.init();
        if (rps.data.isReceived==='y') {
          let url =
            location.origin + "/h5user/beeAfterSureDetails?id=" + rps.data;
          Util.jumpToNewPage({ url: url });
        }
        Util.nativeMethod({ tm: 1000004, tp: { pageCode: 1 } });
      });
    },
    /**
     * 作废外部券
     */
    abolishExternalCoupon() {
      http({
        url: 'order/app/newafter/virtualGoodsCoupon/abolish',
        method: 'post',
        parmes: { orderItemId: this.info.itemVO[0].id }
      })
    },
    voucherImgKeysFun() {
      Util.upLoadImg();
    },
    close(index) {
      this.voucherImgKeys.splice(index, 1);
      this.voucherImgUrls.splice(index, 1);
    },
    getAddresListFun() {
      for (const key in this.addAdressForm) {
        this.addAdressForm[key] = "";
      }
      this.shiqu = "";
      http({
        url: "order/app/branch/address/page",
        method: "post",
        parmes: { branchId: this.info.pointRelatedBranchId || this.info.branchId },
      }).then((rps) => {
        this.resonList = rps.data;
        this.backAddressVisible = true;
      });
    },
    checkAddresListFun() {
      if (!this.radio) {
        this.$toast("请选择寄回地址");
        return;
      }
      this.doSureFun("y");
    },
    addAdressVisebelOpenFun() {
      this.backAddressVisible = !this.backAddressVisible;
      this.addAddressVisible = !this.addAddressVisible;
    },
    onConfirm(val) {
      if (val && val.length > 0) {
        this.addAdressForm.provinceId = val[0].code;
        this.addAdressForm.provinceName = val[0].name;
        this.addAdressForm.cityId = val[1].code;
        this.addAdressForm.cityName = val[1].name;
        this.addAdressForm.areaId = val[2].code;
        this.addAdressForm.areaName = val[2].name;
        this.shiqu = val[0].name + "/" + val[1].name + "/" + val[2].name;
        this.showArea = false;
      }
    },
    checkAdFun() {
      if (!this.shiqu) {
        Toast("请选择省市区");
        return;
      }
      if (!this.addAdressForm.address.replace(/\s/g, "")) {
        Toast("地址不能为空");
        return;
      }
      if (!this.addAdressForm.userName.replace(/\s/g, "")) {
        Toast("收货人姓名不能为空");
        return;
      }
      if (!this.addAdressForm.userMobile.replace(/\s/g, "")) {
        Toast("收货人手机不能为空");
        return;
      }
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.addAdressForm.userMobile)) {
        Toast("请输入正确的的手机号码");
        return;
      }
      this.doAdd();
    },
    doAdd() {
      this.addAdressFormLoading = true;
      this.addAdressForm.branchId = this.info.pointRelatedBranchId || this.info.branchId;
      http({
        url: "order/app/branch/address/add",
        method: "post",
        parmes: this.addAdressForm,
      }).then((rps) => {
        this.addAdressFormLoading = false;
        this.addAddressVisible = false;
        this.getAddresListFun();
      });
    },
    doSureSecondFun(isPass) {
      if (isPass == "n") {
        if (!this.remark.replace(/\s/g, "")) {
          Toast("拒绝原因不能为空");
          return;
        }
      }
      if (isPass == "y") {
        if (!this.checkPrice) {
          Toast("退款金额不能为空");
          return;
        }
        if (
          this.checkPrice &&
          Number(this.checkPrice) > this.info.lastRefundPrice
        ) {
          Toast("退款金额不能大于最大可退金额");
          return;
        }

        // if (!this.refundPointNum) {
        //   Toast("退积分不能为空");
        //   return;
        // }
        if (
          this.refundPointNum &&  Number(this.refundPointNum) > this.info.refundPointNum
        ) {
          Toast("退积分不能大于最大可退积分");
          return;
        }

        
      }
      this.doSureSecondLoading = true;
      let param = {
        actualRefundPrice: 0,
        branchAddressId: 0,
        checkPrice: this.checkPrice,
        refundPointNum: this.refundPointNum,
        id: this.info.id,
        isPass: isPass,
        reason: "",
        remark: this.remark,
        voucherImgKeys: this.voucherImgKeys.join(",") || "",
      };
      http({
        url: "order/admin/afternew/order/checkgoods",
        method: "post",
        parmes: param,
      }).then((rps) => {
        this.loading = false;
        this.yesVisible = false;
        this.rejectVisibleSecond = false;
        this.doSureSecondLoading = false;
        this.init();
      });
    },
    showMaxImgFun(imgs) {
      Util.showMaxImg(encodeURIComponent(JSON.stringify(imgs)), 0);
    },
    goPageExpress(editor = null) {
      if (editor == "editor") {
        this.$dialog
          .confirm({
            title: "温馨提示",
            message: "请先和客户确认是否已发货，避免用户发货产生纠纷",
            confirmButtonColor: "#F8A651",
          })
          .then(() => {
            this.doGoPageAdress(editor);
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.doGoPageAdress(editor);
      }
    },
    doGoPageAdress(editor) {
      let row = this.info;
      row.editor = editor;
      this.$store.dispatch("setBeeSureAddressData", row);
      this.$router.push({ name: "personnelExpressAgainBychange" });
    },
    onExternalCouponConfirm() {
      this.checkPrice = this.info.lastRefundPrice;
      this.refundPointNum = this.info.refundPointNum;
      this.yesVisible = true;
    },
    goAgreeFun(){
      if(this.isExternalCoupon) {
        http({
          url: "order/app/newafter/virtualGoodsCoupon/status",
          method: "post",
          parmes: { orderItemId: this.info.itemVO[0].id },
        }).then(data => {
          if(data.code === 200 && (data = data.data)) {
            this.externalCouponConfirm.show = true;
            this.externalCouponConfirm.status = data.status;
          } else {
            this.$toast('退款异常，请稍候再试');
          }
        })
        return;
      }
      // 判断退货退款 -店铺第一次审核
      switch(this.info.afterSaleType) {
        case 'CHANGE_PRODUCT': 
          this.$router.push({
            name: "personnelmyAddress",
            query: { branchId: this.info.branchId, afterId: this.info.id },
          });
          break;
        default: 
          this.yesVisibleFun()
          break;
      }
    },
    goRejectFun() {
      switch(this.info.afterSaleType) {
        case 'CHANGE_PRODUCT': 
          this.$router.push({
            name: "personnelAddressReject",
            query: { afterId: this.info.id },
          });
          break;
        case 'MERGE_ITEM_CUSTOM_COMPLAIN_REFUND': 
          this.$router.push({
            name: "personnelComplainReject",
            query: { afterId: this.info.id },
          });
          break;
        default: 
          this.rejectVisible = true
          break;
      }
    },
  },
  created() {
    if (this.$route.query.targetParams) {
      let target = JSON.parse(this.$route.query.targetParams);
      this.afterId = (target.afterId && target.afterId) || "";
      this.init();
    } else {
      this.init();
    }
    this.$loading.hide();
    window["setVoucherImgKeys"] = (res) => {
      console.log('上传回调',res)
      let imgs = JSON.parse(res);
      this.voucherImgKeys.push(imgs.key);
      this.voucherImgUrls.push(imgs);
    };
  },
  components: {
    DetailAComp,
    DetailFComp,
    DetailGComp,
    ContactComp,
    FollowComp,
    RejectInfo,
    abnormalItem,
    DetailF2Comp,
    steps
  },
  computed: {
    stepVisible() {
      if(['售后关闭','售后取消'].includes(this.info.showStatus)){
        return false;
      }else{
        if(['仅退款','退货退款','换货','客诉退款'].includes(this.info.afterSaleTypeDisplayName)){
          return true;
        }else{
          return false;
        }
      }
    },
    isExternalCoupon() {
      return this.info.itemVO[0].virtualGoodsIdType === 3; // 是否外部券
    }
  },
};
</script>
<style lang="less" scoped>
.saleView{
  padding: 0 50px 20px 50px;
  .text{
    font-weight: bold;
  }
  .text:before {
        content: '* ';
        color: red;
    }

  /deep/.van-cell{
    border: 1px solid #DDDDDD;
    border-radius:10px ;
    margin-top: 20px;
  }

}

/deep/.van-grid-item__content{
  padding-left: 0;
}
.sales{
  text-align: right;
  padding-top: 10px;
  font-size: 28px;
  padding-bottom: 30px;
}
.after_good{
  display: flex;
  align-items: center;
  img{
   width: 180px;
   height: 180px;
   border-radius: 16px ;
  }
  .img {
   position: relative;
  }
  .group-buying-people-label {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    height: 26px;
    font-size: 18px;
    padding: 0 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    line-height: 1;
  }
  .info{
    display: flex;
    align-content: center;
    flex-direction: column;
    flex: 1;
    padding-left: 20px;
    .info_good :first-child{
      padding-bottom: 44px;
      font-size: 28px;
    }
    
    .info_good{
      display: flex;
      align-content: center;
      justify-content: space-between;
 

     
    }
    .info_sku{
      font-size: 24px;
      color: #898887;
      display: flex;
      justify-content: space-between;
    }
  }

}
.after_goods_list:not(:last-child){
  border-bottom:1px solid #E1E1E1 ;
}
.after_goods_list{
  padding-top: 10px;
}

.after_titlc{
  font-size: 26px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
}
.money{
        color:#ED3939;
      }
  .div-nei {
    overflow-y: hidden;
    display: flex;
    .div-view{
      width: 100%;
    }
   
    .div-one {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .div-info {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex: 1;
      p {
        font-size: 26px;
      }
    }
    }
    .after-money{
      text-align: right;
    }
    div {
      margin-right: 15px;
    }
  }
.countText{
  color: #666;
  font-size: 24px;
}
.countTimer{
   font-size: 24px;
   color: #ED3939;
   font-weight: 600;
}
.btnlfte{border-bottom-left-radius: 20px;}
.btnright{border-bottom-right-radius: 20px;}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.zon {
  position: relative;
  .new-div-by {
    height: 124px;
    width: 100%;
    background-color: var(--epButtonColor);
  }
}
.div-by {
  width: 90%;
  margin-top: -86px;
  margin-left: 5%;
  font-size: 0.4rem;
  margin-bottom: 120px;
  li {
    margin-bottom: 20px;
  }
  .li1 {
    // height: 100px;
    // line-height: 100px;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    border-radius: 0.15rem;
    background-color: #fff;
    padding: 20px 20px;
    .van-row{
      display: flex;
      align-items: center;
    }
    .video_text{
      font-size: 20px;
      color: #999;
    }
    .f32 {
      font-size: 32px;
      color: #333333;
      font-weight: bold;
    }
  }
  .li2 {
    background-color: #fff;
    // padding: 30px;
    h3 {
      font-size: 26px;
      color: #333333;
      margin-left: 10px;
      margin-bottom: 25px;
    }
    .div {
      // max-height: 510px;
      // overflow-y: auto;
      margin-bottom: 10px;
    }
  }
}
.div-mia {
  font-size: 0.3rem;
  border-radius: 0.15rem;
  background-color: #fff;
  padding: 40px;
  text-align: left;
  li .van-row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    div:first-child{
      color: #808080;
    }
  }
}
.aaa {
  margin-top: 12px;
}
.div-dib {
  width: 100%;
  background-color: #fff;
  height: 100px;
  .van-button--default{
    border-color: #999;
  }
  .div-btn-a {
    // border-radius: 30px;
    min-width: 160px;
    font-size: 24px;
    height: 60px;
    line-height: 70px;
    text-align: center;
    margin-right: 20px;
    // margin-bottom: 10px;
    color: #333333;
  }
  .mar-5 {
    // margin-bottom: 30px;
  }
  .mar-10 {
    margin-right: 10px;
    // margin-bottom: 30px;
  }
}
.modal_border {
  /deep/.van-field__body > textarea {
    border: 1px solid #f2f2f2;
    padding: 20px;
    
  }
}
.block {
  width: 80%;
  background-color: #fff;
  border-radius: 0.2rem;
  .btn {
    width: 50%;
    height: 100px;
    line-height: 100px;
  }
  .block-div {
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 30px;
    position: relative;
    h5{
      span{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ED3939;
      margin-left: 10px;
      vertical-align: top ;
    }
    }
    .block-div-sales{
      // position: absolute;
      text-align: center;
      font-size: 24px;
      right: 50px;
      top: 25px;
      font-size:32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      padding-bottom: 20px;
      .status{
        border-radius: 10px;
        border: 1px solid #ED3939;
        padding: 0px 10px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 22px;
        color: #ED3939;
      }
    }
    /deep/.van-field__body > input {
      border: 1px solid #f2f2f2;
      height: 64px;
      line-height: 64px;
      padding-left: 20px;
    }
    .tips {
      width: 500px;
      font-size: 24px;
      color: #ed3939;
      line-height: 28px;
      margin-bottom: 20px;
    }
    /deep/.van-checkbox__label {
      font-size: 24px;
      color: #999999;
    }
  }
  .text {
    margin-bottom: 18px;
  }
  .content {
    display: block;
    align-items: center;
    justify-content: center;
    padding-bottom: 24px;
    .bor {
      padding: 0.26525rem 0;
      margin-bottom: 15px;
    }
    .img_up {
      margin-bottom: 30px;
    }
    .img_up_div {
      position: relative;
      display: inline-block;
      width: 200px;
      height: 200px;
      margin: 5px;
      .close {
        color: red;
        font-weight: bold;
        position: absolute;
        right: 8px;
        font-size: 24px;
      }
    }
    .div-up {
      border: 3px dotted #ccc;
      width: 2rem;
      height: 2rem;
      position: relative;
      .div-up-1 {
        position: absolute;
        top: 30%;
        left: 30%;
      }
    }
    .tex-p {
      font-size: 22px;
      color: #999999;
      margin-bottom: 41px;
    }
    .btext {
      font-size: 24px;
      color: #999999;
    }
    .bu_hr {
      border-top: 1px solid #cccccc;
      margin-left: -50px;
      margin-right: -50px;
      padding-bottom: 30px;
    }
    .bu_div {
      .p1 {
        color: #333333;
        font-size: 28px;
        margin-top: 23px;
      }
      .p2 {
        font-size: 24px;
        color: #999999;
        margin-top: 10px;
        margin-bottom: 23px;
      }
    }
  }
  .text {
    font-size: 28px;
  }
  .mat-10 {
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .yel-b {
    color: #f8a651;
  }
}
/deep/.van-cell:not(:last-child)::after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0;
  bottom: 0;
  left: 0.4244rem;
  border-bottom: 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.navbar-fixed {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 3;
  border-top: 0.01rem solid #fafafa;
  padding-bottom: 8px;
  padding-right: 10px;
  .mar-5 {
    // margin-bottom: 36px;
  }
}

/deep/ .mal-10 {
  // margin-left: 10px;
  background: var(--epButtonColor);
  border: 1px solid var(--epButtonColor);
  color: var(--epTextColor);
}

.rig {
  text-align: right;
  word-break:break-all; 
}
.llt{
  text-align: left;
}
.mr-10 {
  margin-right: 0.35rem;
  color: #333333;
}

.div-content {
  font-size: 0.4rem;
  padding: 0.5rem;
  /deep/.d-r > .van-cell {
    padding: 0 0;
  }
 /deep/ .van-radio-group{
  width: 100%;  
}
/deep/.van-radio{
  // width: 100%;
  background-color: #F7F7F7;
    border-radius: 10px;
    padding: 20px 30px;

}

  // /deep/.van-radio__icon--checked .van-icon {
  //   background-color:var(--buttonColor);
  //   border-color: var(--buttonColor);
  // }

  /deep/.van-radio {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    margin-bottom: 0.3rem;
  }
  .d-que {
    .div-btn {
      border-radius: 0.5rem;
      font-size: 0.3rem;
      width: 160px;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      margin: 0 10px;
    }
    margin-top: 1rem;
    .d-que-l {
      text-align: right;
    }
    .tt {
      height: 1rem;
      line-height: 1rem;
      width: 4rem;
    }
    .cor33 {
      color: #333;
    }
    .wt{
      color: #999;
    }
  }
}
.shet {
  display: flex;
  justify-content: space-between;
  div {
    width: 50%;
    margin-top: 49px;
  }
  .lef {
    font-size: 32px;
    padding-left: 40px;
  }
  .rig {
    text-align: center;
    font-size: 24px;
    height: 58px;
    line-height: 58px;
    color: #999;
    border-radius: 32px;
    margin-right: 30px;
    width: 160px;
    border: 1px solid #999999;

  }
}
.cor99 {
  color: #999;
}
.cor33 {
  color: #333;
}
.yel {
  background: var(--epButtonColor);
  color: var(--epTextColor);
  border: 1px solid var(--epButtonColor);
}
.content_ul {
  padding: 81px 70px 0;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 44px;
  li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }
}
.back_btn {
  width: 300px;
  height: 70px;
  background: var(--epButtonColor);
  border-radius: 40px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: var(--epTextColor);
  line-height: 33px;
  margin: 0 auto;
  display: block;
  margin-bottom: 60px;
  margin-top: 70px;
}
.look-tag {
  padding: 5px 15px;
  border-radius: 10px;
}
.img-icon{
  width: 100px;
}
.w1{
  color:#333;
  font-size: 26px;
  font-weight: 500;
}
.w2{
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ED3939;
  text-align: right !important;
}
.fz{
  height: 32px;
  line-height: 32px;
  padding-top: 2px;
  border-radius: 10px;
}
.auit-info {
  font-size: 24px;
font-weight: 400;
color: #F8A651;
// line-height: 33px;
margin-right: 242px;

}
.print_btn {
  width: 150px;
  // padding: 0 27px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border-radius: 32px;
  border: 1px solid #999999;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin: 20px 0;
  margin-right: 20px;
  &.disabled {
    background: #F2F2F2;
    color: #999999;
    border: 1px solid #F2F2F2;

  }
  .hold_on {
    width: 32px;
    height: 32px;
    margin-left: 8px;
    animation: rotateImg 1s infinite linear;
    
  }
  }
  @keyframes rotateImg {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
.refund-gift-card{
  font-size: 26rpx;
  font-weight: 400;
  color: #898887;
}
.mrr20{
  margin-right: 20px;
}
.price-point{
  display: flex;
  align-items: center;
}
.dialog1 {
  padding: 24px;
  color: #666666;
  .warning1 {
    font-size: 24px;
    color: #f08e3c;
    margin-top: 10px;
    margin-left: 50px;
  }
}
</style>
